import { useMutation } from 'react-query'
// Antd
import { Form, message } from 'antd'
import { useRouter } from '@uirouter/react'
import authService from 'authService'
import axiosRequest from 'utils/axiosRequest'
import { useEffect } from 'react'

const authUrl = process.env.REACT_APP_AUTH_URL

const login = async ({ user, password }) => {
  const { data } = await axiosRequest({
    url: '/auth/login',
    method: 'POST',
    data: {
      username: user,
      password
    },
    baseURL: authUrl
  })

  return data
}

const useLogin = () => {
  const [form] = Form.useForm()
  const { stateService } = useRouter()

  useEffect(() => {
    authService.setGetting(false)
  }, [])

  const { data, isLoading, isError, mutate } = useMutation({
    mutationKey: 'puntos_ideas_login',
    mutationFn: login,
    onSuccess: ({ token }) => {
      const { user } = form.getFieldsValue(true)
      authService.setAuthLogin(token, user)
      stateService.go('App')
    },
    onError: () => {
      message.error({ content: 'Las credenciales ingresadas no son válidas' })
    }
  })

  const onClick = () => {
    mutate(form.getFieldsValue(true))
  }

  return {
    form,
    isLoading,
    isError,
    onClick
  }
}

export default useLogin
